import React, { useMemo, useState } from "react";
import { AppPage, MimaButton, MimaTable } from "../../components";
import constant from "../../utils/constant";
import moment from "moment";
import MimaOptionMenu from "../../components/OptionMenu";
import { adminStore } from "../../stores";
import { AnimatePresence } from "framer-motion";
import { DeleteBroadcastContainer } from "../../containers";

const Broadcast = ({
  closeModal,
  goToDelete,
  deleteBroadcastModal,
  goToCreateBroadcast,
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  goToViewMore,
  goToUpdateBroadcast,
  goToCloneBroadcast,
}) => {
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.broadcasts || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date Created",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY")}</span>;
      },
    },
    {
      Header: "Title",
      accessor: "title",
    },
    {
      Header: "Summary",
      accessor: "summary",
    },
    {
      Header: "Broadcast For",
      accessor: "isFash",
      Cell: ({ cell }) => {
        const broadCastFor = cell.row.original.app;

        return <span>{broadCastFor}</span>;
        // return <span>{isFash ? "FASH CREATIVES" : "MIMA"}</span>;
      },
    },
    {
      Header: "Expected Delivery Date Time",
      accessor: "expectedDeliveryDateTime",
      Cell: ({ cell }) => {
        const expectedDeliveryDateTime =
          cell.row.original.expectedDeliveryDateTime;

        return (
          <span>
            {moment(expectedDeliveryDateTime).format("DD/MM/YYYY h:m a")}
          </span>
        );
      },
    },
    {
      Header: "Delivery Date Time",
      accessor: "deliveryDateTime",
      Cell: ({ cell }) => {
        const deliveryDateTime = cell.row.original.deliveryDateTime;

        return (
          <span>{moment(deliveryDateTime).format("DD/MM/YYYY h:m a")}</span>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const styleClass = `status ${status === "PENDING" ? "status__dark__yellow" : "status__green"}`;
        return <span className={styleClass}>{status}</span>;
      },
    },

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        const status = cell.row.original.status;

        return (
          <MimaOptionMenu
            options={[
              { label: "View More", value: "View More" },
              { label: "Update Broadcast", value: "Update Broadcast" },
              { label: "Clone Broadcast", value: "Clone Broadcast" },
              status === "PENDING"
                ? { label: "Delete Broadcast", value: "Delete Broadcast" }
                : "",
            ]}
            onOptionSelected={(option) => {
              adminStore.setSingleBroadcast(item);
              if (option.value === "View More") {
                goToViewMore();
              } else if (option.value === "Delete Broadcast") {
                goToDelete();
              } else if (option.value === "Update Broadcast") {
                goToUpdateBroadcast();
              } else if (option.value === "Clone Broadcast") {
                goToCloneBroadcast();
              }
            }}
          />
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="Broadcast">
      <MimaButton
        title="Create Broadcast"
        mt={3}
        mb={3}
        onClick={goToCreateBroadcast}
      />
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search Broadcast"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {deleteBroadcastModal && (
        <div className="modal">
          <AnimatePresence>
            {deleteBroadcastModal && (
              <DeleteBroadcastContainer closeModal={closeModal} />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};
export default Broadcast;
